import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap/esm/index";
import { NavLink, Link, useLocation } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/index";

import "./PEDNavigation.scss";

import {
  pushNavHeaderClick,
  pushDownloadEvent,
  pushOutboundClick,
  pushLogoClick,
  pushCTAButtonClick,
  // pushOutboundClickFacebookHeader,
} from "../../assets/datalayerFunctions";

// function showModal(url) {
//   let modal = document.querySelector("#modal");
//   document.body.classList.add("no-scroll");
//   modal.classList.remove("fadeOut");
//   modal.style.display = "block";
//   modal.classList.add("fadeIn");
//   modal.style.height = "100%";
//   modal.children[0].children[1].children[3].href = url;
//   modal.children[0].children[1].children[3].target = "_blank";
//   modal.children[0].children[1].children[3].addEventListener(
//     "click",
//     function () {
//       modal.style.display = "none";
//     },
//   );
// }

// function addModalLinksFacebookHeader(event) {
//   pushOutboundClickFacebookHeader(event);
//   event.preventDefault();
//   let url = event.currentTarget.href;
//   let title = event.target.title;
//   showModal(url, title);
// }

function ITPNavigation(props) {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  let location = useLocation();
  let elementToScrollTo;

  // const startScrollTo = (event) => {
  //   const currentPath = window.location.pathname;
  //   const href = event.target.getAttribute("href");
  //   const hrefParts = href.split("#");
  //   if (hrefParts[0] === currentPath) {
  //     // event.preventDefault();
  //     const element = document.getElementById(hrefParts[1]);
  //     scrollToElement(element);
  //   }
  // };

  const scrollToElement = (element) => {
    setTimeout(() => {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 1000);
  };

  const elementIsVisibleInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  React.useEffect(() => {
    let lastScrollTop = 0;
    const onScroll = (e) => {
      // Check if element is in viewport.
      // Stuff for sidebar isi scrolling.
      const isi = document.getElementById("isi");
      const miniIsi = document.getElementById("mini-isi");
      const isiVisible = elementIsVisibleInViewport(isi);
      const sidebarIsiCollapse = 1280;
      const currentScrollTop =
        e.target.documentElement.scrollTop < 0
          ? 0
          : e.target.documentElement.scrollTop;
      if (currentScrollTop > lastScrollTop) {
        setIsScrollingUp(false);
        // document.body.classList.add('nav-tucked');
        // miniIsi.classList.add('isi-minimized')
      } else if (currentScrollTop < lastScrollTop) {
        setIsScrollingUp(true);
        // document.body.classList.remove('nav-tucked', 'isi-minimized');
        // miniIsi.classList.remove('isi-minimized')
      }
      lastScrollTop = currentScrollTop;

      if (isiVisible && window.innerWidth <= sidebarIsiCollapse) {
        miniIsi.style.display = "none";
      } else {
        miniIsi.style.display = "";
      }
    };
    window.addEventListener("scroll", onScroll);

    // Scroll to hash when page loads.
    let hash = window.location.hash;
    if (hash) {
      hash = hash.slice(1);
      const element = document.getElementById(hash);
      scrollToElement(element);
    }

    return () => window.removeEventListener("scroll", onScroll);
  }, [elementToScrollTo]);

  return (
    <header
      className={`header ped-header ${isNavOpen ? "navOpen" : ""} ${props.isLandingPage ? "landing-page" : ""} `}
    >
      <div className="utility-nav itp-nav">
        <Container>
          <div className="menu_wrap-mobile">
            <ul>
              <li>
                <NavLink
                  to="/pediatric-itp/what-is-doptelet-for-children/"
                  activeClassName="is-active"
                  onClick={(event) => {
                    setIsNavOpen(!isNavOpen);
                    document
                      .querySelector("body")
                      .classList.contains("nav-open")
                      ? document
                        .querySelector("body")
                        .classList.remove("nav-open")
                      : document
                        .querySelector("body")
                        .classList.add("nav-open");
                    pushNavHeaderClick(event);
                  }}
                  title="Doptelet for Children"
                >
                  Doptelet for Children
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/pediatric-itp/taking-doptelet-for-children/"
                  activeClassName="is-active"
                  onClick={(event) => {
                    setIsNavOpen(!isNavOpen);
                    document
                      .querySelector("body")
                      .classList.contains("nav-open")
                      ? document
                        .querySelector("body")
                        .classList.remove("nav-open")
                      : document
                        .querySelector("body")
                        .classList.add("nav-open");
                    pushNavHeaderClick(event);
                  }}
                >
                  Taking Doptelet
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/pediatric-itp/support-and-resources/itp-caregiver-resources/"
                  activeClassName="is-active"
                  onClick={(event) => {
                    setIsNavOpen(!isNavOpen);
                    document
                      .querySelector("body")
                      .classList.contains("nav-open")
                      ? document
                        .querySelector("body")
                        .classList.remove("nav-open")
                      : document
                        .querySelector("body")
                        .classList.add("nav-open");
                    pushNavHeaderClick(event);
                  }}
                >
                  Resources
                </NavLink>
                <ul>
                  <li>
                    <NavLink
                      to="/pediatric-itp/support-and-resources/caregiver-financial-assistance/"
                      activeClassName="is-active"
                      onClick={(event) => {
                        setIsNavOpen(!isNavOpen);
                        document
                          .querySelector("body")
                          .classList.contains("nav-open")
                          ? document
                            .querySelector("body")
                            .classList.remove("nav-open")
                          : document
                            .querySelector("body")
                            .classList.add("nav-open");
                        pushNavHeaderClick(event);
                      }}
                    >
                      Financial Assistance Information
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/pediatric-itp/support-and-resources/itp-faqs/"
                      activeClassName="is-active"
                      onClick={(event) => {
                        setIsNavOpen(!isNavOpen);
                        document
                          .querySelector("body")
                          .classList.contains("nav-open")
                          ? document
                            .querySelector("body")
                            .classList.remove("nav-open")
                          : document
                            .querySelector("body")
                            .classList.add("nav-open");
                        pushNavHeaderClick(event);
                      }}
                    >
                      Patient Resources &amp; FAQs
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/pediatric-itp/support-and-resources/caring-for-child-with-itp/"
                      activeClassName="is-active"
                      onClick={(event) => {
                        setIsNavOpen(!isNavOpen);
                        document
                          .querySelector("body")
                          .classList.contains("nav-open")
                          ? document
                            .querySelector("body")
                            .classList.remove("nav-open")
                          : document
                            .querySelector("body")
                            .classList.add("nav-open");
                        pushNavHeaderClick(event);
                      }}
                    >
                      Stay Connected
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li className="no-mobile-border">
                <NavLink
                  to="/pediatric-itp/what-is-itp-in-children/"
                  activeClassName="is-active"
                  onClick={(event) => {
                    setIsNavOpen(!isNavOpen);
                    document
                      .querySelector("body")
                      .classList.contains("nav-open")
                      ? document
                        .querySelector("body")
                        .classList.remove("nav-open")
                      : document
                        .querySelector("body")
                        .classList.add("nav-open");
                    pushNavHeaderClick(event);
                  }}
                >
                  About Persistent & Chronic ITP
                </NavLink>
              </li>
              <li className="buttonListItem">
                <Link
                  to={{
                    pathname: "/pdf/PP-29112_Doptelet_US_Commercial_Digital-Caregiver-Brochure.pdf"
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                // onClick={(event) => {
                //   pushDownloadEvent(event);
                //   if (
                //     document
                //       .querySelector(".header")
                //       .classList.contains("navOpen")
                //   ) {
                //     setIsNavOpen(!isNavOpen);
                //     document
                //       .querySelector("body")
                //       .classList.contains("nav-open")
                //       ? document
                //         .querySelector("body")
                //         .classList.remove("nav-open")
                //       : document
                //         .querySelector("body")
                //         .classList.add("nav-open");
                //   }
                // }}
                >
                  <span>Download Brochure</span>
                </Link>
                {/* <a
                  href="/pdf/PP-29112_Doptelet_US_Commercial_Digital-Caregiver-Brochure.pdf"
                  className="btn btn-primary"
                  target="_blank"
                >
                  <span>Download Brochure</span>
                </a>*/}
              </li>
            </ul>
          </div>
          <ul className="utility-nav-wrapper justify-content-end">
            <li>
              <a href="/home/">Doptelet for Chronic ITP in Adults</a>
            </li>
            <li>
              <a href="/cld/">Doptelet for CLD</a>
            </li>
            <li>
              <a href="#isi">Important Safety Information</a>
            </li>
            <li>
              <Link
                to={{
                  pathname: "/themes/pdf/prescribing-information.pdf",
                }}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(event) => {
                  pushDownloadEvent(event);
                  if (
                    document
                      .querySelector(".header")
                      .classList.contains("navOpen")
                  ) {
                    setIsNavOpen(!isNavOpen);
                    document
                      .querySelector("body")
                      .classList.contains("nav-open")
                      ? document
                        .querySelector("body")
                        .classList.remove("nav-open")
                      : document
                        .querySelector("body")
                        .classList.add("nav-open");
                  }
                }}
              >
                Prescribing Information
              </Link>
            </li>
            <li>
              <Link
                to={{
                  pathname: "https://doptelet.com/themes/pdf/patient-information-leaflet.pdf",
                }}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(event) => {
                  pushDownloadEvent(event);
                  if (
                    document
                      .querySelector(".header")
                      .classList.contains("navOpen")
                  ) {
                    setIsNavOpen(!isNavOpen);
                    document
                      .querySelector("body")
                      .classList.contains("nav-open")
                      ? document
                        .querySelector("body")
                        .classList.remove("nav-open")
                      : document
                        .querySelector("body")
                        .classList.add("nav-open");
                  }
                }}
              >
                Patient Information
              </Link>
            </li>
            <li>
              <Link
                to={{
                  pathname: "https://doptelet.com/themes/pdf/Instructions-for-Use.pdf"
                }}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(event) => {
                  pushDownloadEvent(event);
                  if (
                    document
                      .querySelector(".header")
                      .classList.contains("navOpen")
                  ) {
                    setIsNavOpen(!isNavOpen);
                    document
                      .querySelector("body")
                      .classList.contains("nav-open")
                      ? document
                        .querySelector("body")
                        .classList.remove("nav-open")
                      : document
                        .querySelector("body")
                        .classList.add("nav-open");
                  }
                }}
              >
                Instructions for Use
              </Link>
              {/* <a href="/themes/pdf/Instructions-for-Use.pdf">Instructions for Use</a>*/}
            </li>
            <li className="hcp-link">
              <Link
                to={{ pathname: "https://doptelethcp.com/" }}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(event) => {
                  pushOutboundClick(event);
                  if (
                    document
                      .querySelector(".header")
                      .classList.contains("navOpen")
                  ) {
                    setIsNavOpen(!isNavOpen);
                    document
                      .querySelector("body")
                      .classList.contains("nav-open")
                      ? document
                        .querySelector("body")
                        .classList.remove("nav-open")
                      : document
                        .querySelector("body")
                        .classList.add("nav-open");
                  }
                }}
              >
                Healthcare Professionals
              </Link>
            </li>
          </ul>
        </Container>
      </div>

      <div className="nav_wrap">
        <Container className="menu-container">
          <Row className="align-items-center justify-content-between">
            <Col xs={3} className="logo-wrapper">
              <Link
                to="/pediatric-itp/what-is-doptelet-for-children/"
                onClick={(event) => {
                  pushLogoClick(event);
                  if (
                    document
                      .querySelector(".header")
                      .classList.contains("navOpen")
                  ) {
                    setIsNavOpen(!isNavOpen);
                    document
                      .querySelector("body")
                      .classList.contains("nav-open")
                      ? document
                        .querySelector("body")
                        .classList.remove("nav-open")
                      : document
                        .querySelector("body")
                        .classList.add("nav-open");
                  }
                }}
              >
                <img
                  alt="Doptelet avatrombopag Tablets Logo"
                  src="/images/doptelet-tablet-sprinkle-logo.svg"
                />
              </Link>
            </Col>
            <Col xs={9} className="link-wrapper pr-0">
              <div className="menu_wrap">
                <ul>
                  <li>
                    <NavLink
                      to="/pediatric-itp/what-is-doptelet-for-children/"
                      className={
                        location.pathname === "/pediatric-itp/what-is-doptelet-for-children/" ||
                          location.pathname === "/pediatric-itp/what-is-doptelet-for-children"
                          ? "is-active"
                          : ""
                      }
                      // activeClassName="is-active"
                      onClick={pushNavHeaderClick}
                      title="Doptelet for Children"
                    >
                      Doptelet for Children
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/pediatric-itp/taking-doptelet-for-children/"
                      activeClassName="is-active"
                      onClick={pushNavHeaderClick}
                      title="Taking Doptelet"
                    >
                      Taking Doptelet
                    </NavLink>
                  </li>

                  <li
                    className={
                      location.pathname === "/pediatric-itp/support-and-resources/itp-caregiver-resources/"
                        ? "active-submenu submenu-link"
                        : "submenu-link"
                    }
                  >
                    <NavLink
                      to="/pediatric-itp/support-and-resources/itp-caregiver-resources/"
                      activeClassName="is-active"
                      onClick={pushNavHeaderClick}
                      title="Resources"
                    >
                      Resources
                    </NavLink>
                    <FontAwesomeIcon icon={faAngleDown} />
                    <ul className="sub_menu">
                      <li>
                        <NavLink
                          to="/pediatric-itp/support-and-resources/caregiver-financial-assistance/"
                          activeClassName="is-active"
                          onClick={pushNavHeaderClick}
                          title="Financial Assistance Information"
                        >
                          Financial Assistance Information
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/pediatric-itp/support-and-resources/itp-faqs/"
                          activeClassName="is-active"
                          onClick={pushNavHeaderClick}
                          title="Patient Resources &amp; FAQs"
                        >
                          Patient Resources &amp; FAQs
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/pediatric-itp/support-and-resources/caring-for-child-with-itp/"
                          activeClassName="is-active"
                          onClick={pushNavHeaderClick}
                          title="Stay Connected"
                        >
                          Stay Connected
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink
                      to="/pediatric-itp/what-is-itp-in-children/"
                      activeClassName="is-active"
                      onClick={pushNavHeaderClick}
                      title="About Persistent &amp; Chronic ITP"
                    >
                      About Persistent &<br></br> Chronic ITP
                    </NavLink>
                  </li>
                  <li className="buttonListItem">
                    <Link
                      to={{
                        pathname: "/pdf/PP-29112_Doptelet_US_Commercial_Digital-Caregiver-Brochure.pdf"
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    // onClick={(event) => {
                    //   pushDownloadEvent(event);
                    //   if (
                    //     document
                    //       .querySelector(".header")
                    //       .classList.contains("navOpen")
                    //   ) {
                    //     setIsNavOpen(!isNavOpen);
                    //     document
                    //       .querySelector("body")
                    //       .classList.contains("nav-open")
                    //       ? document
                    //         .querySelector("body")
                    //         .classList.remove("nav-open")
                    //       : document
                    //         .querySelector("body")
                    //         .classList.add("nav-open");
                    //   }
                    // }}
                    >
                      <span>Download Brochure</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
          <a
            href="/pdf/PP-29112_Doptelet_US_Commercial_Digital-Caregiver-Brochure.pdf"
            className="btn btn-primary d-none mobile-get-tips"
            target="_blank"
          // onClick={(event) => {
          //   setIsNavOpen(!isNavOpen);
          //   document.querySelector("body").classList.contains("nav-open")
          //     ? document.querySelector("body").classList.remove("nav-open")
          //     : document.querySelector("body").classList.add("nav-open");
          //   pushNavHeaderClick(event);
          // }}
          >
            <span>Download Brochure</span>
          </a>
          <div
            className="menu_btn"
            onClick={() => {
              setIsNavOpen(!isNavOpen);
              document.querySelector("body").classList.contains("nav-open")
                ? document.querySelector("body").classList.remove("nav-open")
                : document.querySelector("body").classList.add("nav-open");
            }}
          >
            <span className="bars">
              <span></span>
              <span></span>
              <span></span>
            </span>

            <div>Menu</div>
            <div>Close</div>
          </div>
          <a
            target="_blank"
            className="get-the-guide d-none"
            href="/pdf/Dr-Discussion-Guide.pdf"
          >
            Get the Guide
          </a>
        </Container>
      </div>
      <div
        className="open-nav-overlay"
        onClick={() => {
          setIsNavOpen(!isNavOpen);
          document.querySelector("body").classList.contains("nav-open")
            ? document.querySelector("body").classList.remove("nav-open")
            : document.querySelector("body").classList.add("nav-open");
        }}
      ></div>
      <div id="phreesia-modal" className="modal-modal">
        <div className="modal-container">
          <div className="exitBtn">
            <img src="/images/close.png" alt="Close Button Icon" />
          </div>
          <div className="content">
            <div id="medifind-doctor-specialty-widget"></div>
            <p className="text-left">
              <small>
                Sobi is providing this free tool to help you find healthcare
                providers in your area who may have experience treating chronic
                ITP. Neither Sobi nor MediFind pay healthcare providers to be
                listed in this tool and healthcare providers do not pay to be
                listed in the tool. Just because a healthcare provider is listed
                in the tool does not mean Sobi endorses their qualifications or
                recommends their medical care. The search results of healthcare
                providers are sorted by the distance from the location entered.
                Choosing a healthcare provider is an important decision
                requiring careful consideration. Sobi is not responsible for
                your choice or actions you take because of information provided
                by the tool.
              </small>
            </p>
          </div>
        </div>
        <div className="modal-overlay overlay"></div>
      </div>
    </header >
  );
}

export default ITPNavigation;
